export default "__VITE_ASSET__itghLbC0__"